import { Moment, utc } from "moment";

export function getUtcDateFormatted(date: Moment) {
    return utc(date).format();
}
